// Copyright (c) 2024, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { AccountState,AccountType } from "./types";

export const isIncludedRole = (a: string[], b: string[]): boolean => {
  return [...getCrossItems(a, b), ...getCrossItems(b, a)].length > 0;
};

function getCrossItems<Role>(a: Role[], b: Role[]): Role[] {
  return a.filter((element) => {
    return b.includes(element);
  });
}

export const getAccountStateColorStrings = (status: AccountState) => {
  if (status === AccountState.INACTIVE) {
    return "default";
  } else if (status === AccountState.REQUESTED) {
    return "warning";
  } else if (status === AccountState.ACTIVE) {
    return "success";
  } else if (status === AccountState.REJECTED) {
    return "error";
  } else {
    return "primary";
  }
};

export const getAccountTypeColorStrings = (type: AccountType) => {
  if (type === AccountType.SALARY) {
    return "success";
  } else if (type === AccountType.CONSULTANCY) {
    return "warning";
  } else if (type === AccountType.REIMBURSEMENT) {
    return "default";
  }
};

// Generic: is `country` in the given list.
export const isCountryInList = (
  country: string,
  countries: string[] | undefined
): boolean => {
  return !!countries?.includes(country);
};

// Reimbursement Country Eligibility: is `country` in the effective allowed-countries list.
export const isReimbursementEligible = (
  country: string,
  allowedCountries: string[] | undefined
): boolean => {
  return isCountryInList(country, allowedCountries);
};

export const formatOrdinal = (number: number) => {
  if (number % 100 >= 11 && number % 100 <= 13) {
    return  `${number}th`;
  }
  switch (number % 10) {
    case 1:
      return `${number}st`;
    case 2:
      return `${number}nd`;
    case 3:
      return `${number}rd`;
    default:
      return `${number}th`;
  }
};
